// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-container {
  padding: 20px;
  max-width: 1600px;
  background-color: #ddd;
}

.services-header {
  text-align: left;
  margin-bottom: 20px;
  font-size: 2rem;
  font-weight: bold;
  
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 20fr));
  gap: 20px;
}

.service-card {
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

/* Sticky image styling */
.sticky-card .service-image-container {
  position: relative;
}

.sticky-card .sticky-image {
  position: sticky;
  top: 200px;
  width: 100%;
  height: auto;
  margin-top: -200%;
  margin-bottom: -19%;
}
.it-image
{
  position: sticky;
}
.moving-images {
  position: absolute; /* Ensure it's absolutely positioned relative to the parent card */
  bottom: 29%!important; /* Move the moving images slightly above the bottom */
  right: -8%; /* Center horizontally */
  
  transform: translateX(-50%); /* Adjust horizontal alignment */
  width: 350%; /* Optional: Set width for consistency */
  display: flex;
  justify-content: center;
  pointer-events: none; /* Prevent interaction with the moving images */
  transition: transform 0s ease-in-out; 
  animation: moveImages 10s linear infinite; /* Animation for movement */
  gap: 35%;
  flex-shrink: 0;
}


.moving-image {
  width: 120px; /* Adjust size of the moving images */
  height: auto;
  gap:25%;
  /* margin-right: 10px; */
}
.moving-image.active {
  left: 0;
  opacity: 10;
  z-index: 10;
}

.moving-image.inactive {
  left: -100%;
  opacity: 0;
  z-index: 0;
}
/* Custom styles for specific images */


.it-image {
  width: 120px;
  height: 120px;
  border: 2px solid #ddd;
  margin-top: -80px;
}

.engineering-image {
  width: 140px;
  height: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.other-image {
  width: 130px;
  height: 130px;
  border: 2px solid #ccc;
}

/* Set specific background images for cards 1, 2, and 3 */


/* Keyframes to move images from left to right */
@keyframes moveImages {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes slide-in {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX();
    opacity: 1;
  }
}

/* Card content */

/* Horizontal line above the button */
.service-divider {
  margin-bottom: 15px; /* Adds space between the line and button */
  border-top: 1px solid #ddd; /* Light gray horizontal line */
}

/* Button styling */
.service-button {
  margin-bottom: 8px;
  padding: 10px 10px;
  margin-left: 60%;
  background-color: rgb(255, 255, 255);
  color: #15801e;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 100%;
  align-self: flex-start;
}

.service-button:hover {
  background-color: #6adb73;
  color: white;
  transition: 0.3s;
}

.service-detail {
  text-align: center;
  padding: 20px;
}

.service-detail-image {
  width: 100%;
  height: auto;
  max-width: 400px;
  margin: 0 auto;
  display: block;
}

.service-detail-title {
  font-size: 2rem;
  margin-top: 20px;
}

.service-detail-description {
  font-size: 1.1rem;
  margin-top: 10px;
  color: #555;
}

.back-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #0056b3;
}
.service-card:hover {
  transform: translateY(-10px); /* Move the entire card up slightly */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Add a deeper shadow for emphasis */
}
.service-image-container {
  position: relative;
  width: 100%;
  height: 90%;
  overflow: hidden;
}
.service-card:hover .service-image {
  transform: scale(1.1)translateY(-10px); /* Scale up the image slightly on hover */
}
.service-card-content {
  padding: 20px;
  flex: 1 1; /* Allow content to stretch */
  transition: transform 0.5s ease-in-out;
}
@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr; /* Single-column layout for mobile */
    gap: 15px; /* Smaller gaps between cards */
  }

  .service-card {
    border-radius: 4px; /* Slightly less rounded corners */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); /* Softer shadow */
  }

  .service-image {
    width: 100%;
    height: auto; /* Maintain the aspect ratio */
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .service-button {
    font-size: 12px; /* Smaller button text */
    padding: 8px 16px; /* Smaller button size */
    margin-left: 0; /* Center align button for mobile */
    align-self: center; /* Adjust alignment for the button */
  }
  
  
}










@media (min-width: 1366px) and (min-height: 768px) {
  .services-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Adjust column size */
    gap: 25px; /* Adjust gap for larger screens */
  }
  


  .service-card {
    border-radius: 10px; /* Slightly more rounded corners for large screens */
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1); /* Deeper shadow for larger screens */
    padding: 20px;
  }

  .services-header {
    font-size: 2.5rem; /* Larger header font size */
  }

  .service-button {
    font-size: 16px; /* Larger button text */
    padding: 12px 20px; /* Bigger button */
    margin-left: auto; /* Align buttons on the right */
  }

  .service-detail {
    max-width: 800px; /* Wider content area for details */
    margin: 0 auto; /* Center the detail section */
  }

  .service-detail-title {
    font-size: 2.5rem; /* Larger titles */
  }
  

  .service-detail-description {
    font-size: 1.3rem; /* Larger description text */
    line-height: 1.8; /* Better readability */
  }

  .service-divider {
    border-top: 2px solid #ddd; /* Thicker divider */
  }
}


    
  

  

/* For larger screens (1366px and above) */
@media (min-width: 1366px) {
  .moving-images {
    bottom: 25%!important; /* Adjust position for larger screens */
    right: -5%; /* Reduce the offset on larger screens */
    width: 300%; /* Adjust width for consistent scaling */
    gap: 20%; /* Reduce gap for better alignment */
  }

  .sticky-card .sticky-image {
   
    height: 78vh!important;
 
  }
  .moving-image {
    width: 100px; /* Increase image size on larger screens */
    height: auto;
    margin-bottom: -4%;
  }

  .it-image {
    width: 140px; /* Increase size for specific images */
    height: 140px;
    margin-top: -60px; /* Adjust spacing */
  }
}

/* For medium screens (1024px - 1366px) */
@media (max-width: 1380px) and (min-width: 1024px) {
  .moving-images {
    bottom: 27%;
    right: -6%;
    width: 320%;
    gap: 22%;
  }

  .moving-image {
    width: 100px;
    height: auto;
  }

  .it-image {
    width: 130px;
    height: 130px;
    margin-top: -70px;
  }

  

}





/* For tablets (768px - 1024px) */
@media (max-width: 1024px) and (min-width: 768px) {
  .moving-images {
    bottom: 18%; /* Adjust position for smaller screens */
    right: -7%; /* Keep images centered */
    width: 280%;
    gap: 18%; /* Narrow gaps for tighter layouts */
  }

  .moving-image {
    width: 90px;
    height: auto;
  }

  .it-image {
    width: 100px;
    height: 100px;
    margin-top: -50px;

  }
 
}

/* For mobile devices (up to 768px) */
@media (max-width: 768px) {
  .moving-images {
    bottom: 23%!important; /* Lower the images for smaller screens */
    right: -10%;
    width: 250%;
    gap: 15%;
  }

  
  .moving-image {
    width: 100px; /* Adjust size of the moving images */
    height: auto;
    gap:25%;
    /* margin-right: 10px; */
  }
  .it-image {
    width: 80px;
    height: 80px;
    margin-top: -40px;
  }
  .sticky-card .sticky-image {
    position: sticky;
    top: 200px;
    width: 100%;
    height: auto;
    margin-top: -2%;
    margin-bottom: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Services/Services.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB,EAAE,kEAAkE;EACtF,qBAAqB,EAAE,qDAAqD;EAC5E,UAAU,EAAE,wBAAwB;;EAEpC,2BAA2B,EAAE,gCAAgC;EAC7D,WAAW,EAAE,wCAAwC;EACrD,aAAa;EACb,uBAAuB;EACvB,oBAAoB,EAAE,+CAA+C;EACrE,oCAAoC;EACpC,yCAAyC,EAAE,2BAA2B;EACtE,QAAQ;EACR,cAAc;AAChB;;;AAGA;EACE,YAAY,EAAE,qCAAqC;EACnD,YAAY;EACZ,OAAO;EACP,wBAAwB;AAC1B;AACA;EACE,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;AACZ;AACA,sCAAsC;;;AAGtC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,yDAAyD;;;AAGzD,gDAAgD;AAChD;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,UAAU;EACZ;AACF;;AAEA,iBAAiB;;AAEjB,qCAAqC;AACrC;EACE,mBAAmB,EAAE,2CAA2C;EAChE,0BAA0B,EAAE,+BAA+B;AAC7D;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B,EAAE,qCAAqC;EACnE,yCAAyC,EAAE,qCAAqC;AAClF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,sCAAsC,EAAE,yCAAyC;AACnF;AACA;EACE,aAAa;EACb,SAAO,EAAE,6BAA6B;EACtC,sCAAsC;AACxC;AACA;EACE;IACE,0BAA0B,EAAE,oCAAoC;IAChE,SAAS,EAAE,+BAA+B;EAC5C;;EAEA;IACE,kBAAkB,EAAE,kCAAkC;IACtD,yCAAyC,EAAE,kBAAkB;EAC/D;;EAEA;IACE,WAAW;IACX,YAAY,EAAE,8BAA8B;IAC5C,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,eAAe,EAAE,wBAAwB;IACzC,iBAAiB,EAAE,wBAAwB;IAC3C,cAAc,EAAE,mCAAmC;IACnD,kBAAkB,EAAE,oCAAoC;EAC1D;;;AAGF;;;;;;;;;;;AAWA;EACE;IACE,2DAA2D,EAAE,uBAAuB;IACpF,SAAS,EAAE,kCAAkC;EAC/C;;;;EAIA;IACE,mBAAmB,EAAE,oDAAoD;IACzE,yCAAyC,EAAE,qCAAqC;IAChF,aAAa;EACf;;EAEA;IACE,iBAAiB,EAAE,4BAA4B;EACjD;;EAEA;IACE,eAAe,EAAE,uBAAuB;IACxC,kBAAkB,EAAE,kBAAkB;IACtC,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,gBAAgB,EAAE,mCAAmC;IACrD,cAAc,EAAE,8BAA8B;EAChD;;EAEA;IACE,iBAAiB,EAAE,kBAAkB;EACvC;;;EAGA;IACE,iBAAiB,EAAE,4BAA4B;IAC/C,gBAAgB,EAAE,uBAAuB;EAC3C;;EAEA;IACE,0BAA0B,EAAE,oBAAoB;EAClD;AACF;;;;;;;;AAQA,0CAA0C;AAC1C;EACE;IACE,qBAAqB,EAAE,uCAAuC;IAC9D,UAAU,EAAE,wCAAwC;IACpD,WAAW,EAAE,wCAAwC;IACrD,QAAQ,EAAE,oCAAoC;EAChD;;EAEA;;IAEE,sBAAsB;;EAExB;EACA;IACE,YAAY,EAAE,0CAA0C;IACxD,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY,EAAE,sCAAsC;IACpD,aAAa;IACb,iBAAiB,EAAE,mBAAmB;EACxC;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;;;AAIF;;;;;;AAMA,iCAAiC;AACjC;EACE;IACE,WAAW,EAAE,wCAAwC;IACrD,UAAU,EAAE,yBAAyB;IACrC,WAAW;IACX,QAAQ,EAAE,oCAAoC;EAChD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;;EAEnB;;AAEF;;AAEA,qCAAqC;AACrC;EACE;IACE,qBAAqB,EAAE,yCAAyC;IAChE,WAAW;IACX,WAAW;IACX,QAAQ;EACV;;;EAGA;IACE,YAAY,EAAE,qCAAqC;IACnD,YAAY;IACZ,OAAO;IACP,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".services-container {\n  padding: 20px;\n  max-width: 1600px;\n  background-color: #ddd;\n}\n\n.services-header {\n  text-align: left;\n  margin-bottom: 20px;\n  font-size: 2rem;\n  font-weight: bold;\n  \n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 20fr));\n  gap: 20px;\n}\n\n.service-card {\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n}\n\n/* Sticky image styling */\n.sticky-card .service-image-container {\n  position: relative;\n}\n\n.sticky-card .sticky-image {\n  position: sticky;\n  top: 200px;\n  width: 100%;\n  height: auto;\n  margin-top: -200%;\n  margin-bottom: -19%;\n}\n.it-image\n{\n  position: sticky;\n}\n.moving-images {\n  position: absolute; /* Ensure it's absolutely positioned relative to the parent card */\n  bottom: 29%!important; /* Move the moving images slightly above the bottom */\n  right: -8%; /* Center horizontally */\n  \n  transform: translateX(-50%); /* Adjust horizontal alignment */\n  width: 350%; /* Optional: Set width for consistency */\n  display: flex;\n  justify-content: center;\n  pointer-events: none; /* Prevent interaction with the moving images */\n  transition: transform 0s ease-in-out; \n  animation: moveImages 10s linear infinite; /* Animation for movement */\n  gap: 35%;\n  flex-shrink: 0;\n}\n\n\n.moving-image {\n  width: 120px; /* Adjust size of the moving images */\n  height: auto;\n  gap:25%;\n  /* margin-right: 10px; */\n}\n.moving-image.active {\n  left: 0;\n  opacity: 10;\n  z-index: 10;\n}\n\n.moving-image.inactive {\n  left: -100%;\n  opacity: 0;\n  z-index: 0;\n}\n/* Custom styles for specific images */\n\n\n.it-image {\n  width: 120px;\n  height: 120px;\n  border: 2px solid #ddd;\n  margin-top: -80px;\n}\n\n.engineering-image {\n  width: 140px;\n  height: auto;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.other-image {\n  width: 130px;\n  height: 130px;\n  border: 2px solid #ccc;\n}\n\n/* Set specific background images for cards 1, 2, and 3 */\n\n\n/* Keyframes to move images from left to right */\n@keyframes moveImages {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n@keyframes slide-in {\n  0% {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX();\n    opacity: 1;\n  }\n}\n\n/* Card content */\n\n/* Horizontal line above the button */\n.service-divider {\n  margin-bottom: 15px; /* Adds space between the line and button */\n  border-top: 1px solid #ddd; /* Light gray horizontal line */\n}\n\n/* Button styling */\n.service-button {\n  margin-bottom: 8px;\n  padding: 10px 10px;\n  margin-left: 60%;\n  background-color: rgb(255, 255, 255);\n  color: #15801e;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 100%;\n  align-self: flex-start;\n}\n\n.service-button:hover {\n  background-color: #6adb73;\n  color: white;\n  transition: 0.3s;\n}\n\n.service-detail {\n  text-align: center;\n  padding: 20px;\n}\n\n.service-detail-image {\n  width: 100%;\n  height: auto;\n  max-width: 400px;\n  margin: 0 auto;\n  display: block;\n}\n\n.service-detail-title {\n  font-size: 2rem;\n  margin-top: 20px;\n}\n\n.service-detail-description {\n  font-size: 1.1rem;\n  margin-top: 10px;\n  color: #555;\n}\n\n.back-button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 20px;\n  transition: background-color 0.3s;\n}\n\n.back-button:hover {\n  background-color: #0056b3;\n}\n.service-card:hover {\n  transform: translateY(-10px); /* Move the entire card up slightly */\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Add a deeper shadow for emphasis */\n}\n.service-image-container {\n  position: relative;\n  width: 100%;\n  height: 90%;\n  overflow: hidden;\n}\n.service-card:hover .service-image {\n  transform: scale(1.1)translateY(-10px); /* Scale up the image slightly on hover */\n}\n.service-card-content {\n  padding: 20px;\n  flex: 1; /* Allow content to stretch */\n  transition: transform 0.5s ease-in-out;\n}\n@media (max-width: 768px) {\n  .services-grid {\n    grid-template-columns: 1fr; /* Single-column layout for mobile */\n    gap: 15px; /* Smaller gaps between cards */\n  }\n\n  .service-card {\n    border-radius: 4px; /* Slightly less rounded corners */\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); /* Softer shadow */\n  }\n\n  .service-image {\n    width: 100%;\n    height: auto; /* Maintain the aspect ratio */\n    object-fit: cover;\n    transition: transform 0.3s ease;\n  }\n\n  .service-button {\n    font-size: 12px; /* Smaller button text */\n    padding: 8px 16px; /* Smaller button size */\n    margin-left: 0; /* Center align button for mobile */\n    align-self: center; /* Adjust alignment for the button */\n  }\n  \n  \n}\n\n\n\n\n\n\n\n\n\n\n@media (min-width: 1366px) and (min-height: 768px) {\n  .services-grid {\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Adjust column size */\n    gap: 25px; /* Adjust gap for larger screens */\n  }\n  \n\n\n  .service-card {\n    border-radius: 10px; /* Slightly more rounded corners for large screens */\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1); /* Deeper shadow for larger screens */\n    padding: 20px;\n  }\n\n  .services-header {\n    font-size: 2.5rem; /* Larger header font size */\n  }\n\n  .service-button {\n    font-size: 16px; /* Larger button text */\n    padding: 12px 20px; /* Bigger button */\n    margin-left: auto; /* Align buttons on the right */\n  }\n\n  .service-detail {\n    max-width: 800px; /* Wider content area for details */\n    margin: 0 auto; /* Center the detail section */\n  }\n\n  .service-detail-title {\n    font-size: 2.5rem; /* Larger titles */\n  }\n  \n\n  .service-detail-description {\n    font-size: 1.3rem; /* Larger description text */\n    line-height: 1.8; /* Better readability */\n  }\n\n  .service-divider {\n    border-top: 2px solid #ddd; /* Thicker divider */\n  }\n}\n\n\n    \n  \n\n  \n\n/* For larger screens (1366px and above) */\n@media (min-width: 1366px) {\n  .moving-images {\n    bottom: 25%!important; /* Adjust position for larger screens */\n    right: -5%; /* Reduce the offset on larger screens */\n    width: 300%; /* Adjust width for consistent scaling */\n    gap: 20%; /* Reduce gap for better alignment */\n  }\n\n  .sticky-card .sticky-image {\n   \n    height: 78vh!important;\n \n  }\n  .moving-image {\n    width: 100px; /* Increase image size on larger screens */\n    height: auto;\n    margin-bottom: -4%;\n  }\n\n  .it-image {\n    width: 140px; /* Increase size for specific images */\n    height: 140px;\n    margin-top: -60px; /* Adjust spacing */\n  }\n}\n\n/* For medium screens (1024px - 1366px) */\n@media (max-width: 1380px) and (min-width: 1024px) {\n  .moving-images {\n    bottom: 27%;\n    right: -6%;\n    width: 320%;\n    gap: 22%;\n  }\n\n  .moving-image {\n    width: 100px;\n    height: auto;\n  }\n\n  .it-image {\n    width: 130px;\n    height: 130px;\n    margin-top: -70px;\n  }\n\n  \n\n}\n\n\n\n\n\n/* For tablets (768px - 1024px) */\n@media (max-width: 1024px) and (min-width: 768px) {\n  .moving-images {\n    bottom: 18%; /* Adjust position for smaller screens */\n    right: -7%; /* Keep images centered */\n    width: 280%;\n    gap: 18%; /* Narrow gaps for tighter layouts */\n  }\n\n  .moving-image {\n    width: 90px;\n    height: auto;\n  }\n\n  .it-image {\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n\n  }\n \n}\n\n/* For mobile devices (up to 768px) */\n@media (max-width: 768px) {\n  .moving-images {\n    bottom: 23%!important; /* Lower the images for smaller screens */\n    right: -10%;\n    width: 250%;\n    gap: 15%;\n  }\n\n  \n  .moving-image {\n    width: 100px; /* Adjust size of the moving images */\n    height: auto;\n    gap:25%;\n    /* margin-right: 10px; */\n  }\n  .it-image {\n    width: 80px;\n    height: 80px;\n    margin-top: -40px;\n  }\n  .sticky-card .sticky-image {\n    position: sticky;\n    top: 200px;\n    width: 100%;\n    height: auto;\n    margin-top: -2%;\n    margin-bottom: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
